/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Bom_QtyInputs */

const vi_packaging_bom_qty = /** @type {(inputs: Packaging_Bom_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng`)
};

/**

* @param {Packaging_Bom_QtyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_bom_qty = /** @type {((inputs?: Packaging_Bom_QtyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Bom_QtyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_bom_qty(inputs)
});